import algoliasearch from 'algoliasearch';
import { StringConstantsMixin } from '../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';

const LOCALIZED_ATTRIBUTES = ['area_name', 'city_name', 'country_name', 'state_name', 'name', 'description'];

class Search {
  constructor(indexId, languageRegionCode) {
    this.algoliaClient = algoliasearch(StringConstantsMixin.constants.ALGOLIA.ACCOUNT, StringConstantsMixin.constants.ALGOLIA.API_KEY);
    this.algoliaIndex = this.algoliaClient.initIndex(indexId);
    this.languageRegionCode = languageRegionCode || LanguageRegionCode.English;
  }

  search(searchTerm, queryObj) {
    return this.algoliaIndex.search(searchTerm, this.optimizeAndLocalizeQuery(searchTerm, queryObj));
  }

  batchSearch(queryObjs) {
    const queries = queryObjs.map(q => {
      return {
        indexName: this.algoliaIndex.indexName,
        query: '',
        params: this.optimizeAndLocalizeQuery('', q)
      };
    });

    return this.algoliaClient.multipleQueries(queries);
  }

  clearCache() {
    this.algoliaClient.clearCache();
  }

  optimizeQuery(searchTerm, query) {
    if (!searchTerm) {
      query.attributesToHighlight = [];
    } else if (!query.attributesToHighlight) {
      query.attributesToHighlight = ['name'];
    }

    if (!query.responseFields) {
      query.responseFields = ['hits', 'hitsPerPage', 'nbHits'];
    }
  }

  localizeQuery(query) {
    if (query.attributesToRetrieve && this.languageRegionCode !== LanguageRegionCode.English) {
      LOCALIZED_ATTRIBUTES.forEach(attr => {
        if (query.attributesToRetrieve.includes(attr)) {
          // TODO: We are going to have to make this aware of > 2 char language codes
          query.attributesToRetrieve.push(`${attr}_${this.languageRegionCode.substring(0, 2)}`);
        }
      });
    }
  }

  optimizeAndLocalizeQuery(searchTerm, query) {
    if (!query.attributesToRetrieve) {
      console.debug('WARNING: No attributesToRetrieve specified');
      console.debug({ searchTerm, query });
    }

    const optimizedQuery = JSON.parse(JSON.stringify(query)); // deep clone

    this.optimizeQuery(searchTerm, optimizedQuery);
    this.localizeQuery(optimizedQuery);

    return optimizedQuery;
  }
}

let defaultIndexId = StringConstantsMixin.constants.ALGOLIA.INDEX;
// Use the alpha algolia index in all environments except production
if (typeof window !== 'undefined' && window.location.host !== 'www.alltrails.com') {
  defaultIndexId = StringConstantsMixin.constants.ALGOLIA.INDEX_ALPHA;
}

const indices = [];

const getAlgoliaIndex = (indexId = defaultIndexId, providedLanguageRegionCode = null) => {
  let languageRegionCode = providedLanguageRegionCode;

  if (!languageRegionCode) {
    languageRegionCode = LanguageRegionCode.English;
  }

  const cacheKey = [indexId, languageRegionCode].join('-');
  indices[cacheKey] ||= new Search(indexId, languageRegionCode);
  return indices[cacheKey];
};

export { Search, getAlgoliaIndex };
